import { SET_ACCOUNT_REPRESENTATIVE } from '../action-types';

export const customerAccountRepresentativeReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case SET_ACCOUNT_REPRESENTATIVE: {
      return {
        ...action.payload
      };
    }
    default:
      return state;
  }
};
